export const colors = {
  primary:         '#634776',
  primaryHover:    '#523664',
  primaryDark:     '#3b1f52',
  primaryLight:    '#BB9CD1',
  primaryBg:       '#F5EEFA',
  primaryBgHover:  '#EEE3F7',

  bg:              '#F7FAFB',
  card:            '#ffffff',
  border:          '#DCE2E6',
  borderLight:     '#EEE3F7',
  text:            '#1C2024',
  textMuted:       '#5D656C',
  textLight:       '#868F97',

  success:         '#1a6648',
  successBg:       '#e4f4ec',
  successBorder:   '#b3dcc8',

  warning:         '#8a4e0e',
  warningBg:       '#fef3e2',
  warningBorder:   '#f5d49a',

  danger:          '#8c2020',
  dangerBg:        '#fce8e8',
  dangerBorder:    '#f5b8b8',

  info:            '#1e40af',
  infoBg:          '#dbeafe',
} as const;

export type AttendanceStatus = 'present' | 'absent' | 'late' | null;

export const statusColors: Record<NonNullable<AttendanceStatus>, { bg: string; text: string; border: string }> = {
  present: { bg: "#eff6ff", text: "#1e40af", border: "#93c5fd" },
  late:    { bg: "#fef9c3", text: "#854d0e", border: "#facc15" },
  absent:  { bg: "#fff7ed", text: "#92400e", border: "#fcd34d" },
};

export const ON_TIME_STYLE = { bg: "#f0fdf4", text: "#166534", border: "#86efac" };

export const avatarPalette = [
  '#7C3AED', '#2563EB', '#059669', '#D97706',
  '#DC2626', '#DB2777', '#0891B2', '#4F46E5',
  '#7C3AED', '#16A34A', '#EA580C', '#0284C7',
];

export function getAvatarColor(name: string): string {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = name.charCodeAt(i) + ((h << 5) - h);
  return avatarPalette[Math.abs(h) % avatarPalette.length];
}
